import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'
import { queryClient } from '../../../App'
import { isAdmin, isDealer } from '../../../services/AccountService'
import { getRequestsTable } from '../../../services/NewApiService'
import { CheckboxStore } from '../../../stores/CheckboxStore'
import NewPaginationStore from '../../../stores/NewPaginationStore'
import { getComp } from '../../../utils/utils/DI'
import { RequestTableParamsType } from '../../RequestsManagement/components/NewRequestsTable/types/new-requests-table.types'
import { REPORT_KEYS } from '../../SingleRequestReport/consts/request-report.keys'

export const initParams: RequestTableParamsType = {
  statuses: [6],
  dataCheckingStatus: [0, 3],
  financialSourceIds: [1, 5] as any,
  SenderGroupIds: [],
}

export const createReportPaginationStore = new NewPaginationStore(initParams)

export const createReportCheckboxStore = new CheckboxStore()

export const useCreateReportTableData = () => {
  const mountedRef = useRef(false) // что-бы setSelectedRow не срабатывал на mount
  const {
    page,
    size,
    sort,
    params: {
      statuses,
      dataCheckingStatus,
      installedTo,
      installedFrom,
      SenderGroupIds,
      financialSourceIds,
      phone,
      address,
      fullName,
      orderId,
    },
    setSelectedRow,
  } = createReportPaginationStore

  useEffect(() => {
    if (mountedRef.current) {
      setSelectedRow(null, 0)
    } else {
      mountedRef.current = true
    }
  }, [
    statuses,
    dataCheckingStatus,
    installedTo,
    installedFrom,
    SenderGroupIds,
    financialSourceIds,
    phone,
    address,
    fullName,
    orderId,
  ])

  const userId = getComp('UserInfoStore')?.info?.id

  return useQuery(
    {
      queryKey: [
        REPORT_KEYS.CREATE_REPORT,
        size,
        page,
        sort,
        statuses,
        dataCheckingStatus,
        installedTo,
        installedFrom,
        SenderGroupIds,
        financialSourceIds,
        phone,
        address,
        fullName,
        orderId,
      ],
      queryFn: () =>
        getRequestsTable({
          size,
          page,
          sort,
          statuses,
          dataCheckingStatus,
          installedTo,
          installedFrom,
          SenderGroupIds,
          financialSourceIds,
          phone,
          address,
          fullName,
          orderId,
        }),
      staleTime: 1000000,
      placeholderData: keepPreviousData,
      enabled: () => !!userId && (!!isAdmin() || !!isDealer()),
    },
    queryClient,
  )
}
